import {
	type AgentSkillAvailability,
	buildSkillCatalogLines,
} from "./agent-skills";

const CORE_AGENT_LINES = [
	"You are Illumi's app assistant. Answer the user directly in this chat. Keep answers in this chat.",
	"When the user must pick one of several concrete options, call presentOptions with a prompt and 2-8 options. After presentOptions, stop the turn and wait.",
	"When context about mentioned people is provided in <people> envelopes, incorporate that context into your responses.",
	"After tools complete, write a short user-visible reply about what you did or found.",
	"Call loadSkill before specialized work. Do not invent rules that were not loaded.",
];

export type AgentSystemPromptOptions = AgentSkillAvailability;

export function buildAgentSystemPrompt(options: AgentSystemPromptOptions = {}) {
	const catalog = buildSkillCatalogLines(options);
	const lines =
		catalog.length === 0
			? [...CORE_AGENT_LINES]
			: [...CORE_AGENT_LINES, "Skills:", ...catalog];

	return lines.join("\n");
}
